import { BrandCard } from "@shltelemedicine/shl-ui-lib";
import styles from "./Login.module.css";
import LoginForm from "./LoginForm/LoginForm";
import SsoLogin from "./SsoLogin";
import Disclaimer from "../Disclaimer/Disclaimer";

type LoginProps = { token: string };

const Login = ({ token }: LoginProps) => {
  return (
    <>
      <BrandCard className={styles.wrapper} contentClassName="mb-4">
        {!token ? <LoginForm /> : <SsoLogin token={token} />}
      </BrandCard>

      <div className={`${styles.warning} text-center mx-sm`}>
        <p className="mt-3 mb-0">
          <Disclaimer />
        </p>
      </div>
    </>
  );
};

export default Login;
